import { TrendDownIcon as PhosphorTrendDownIcon } from "@phosphor-icons/react/dist/ssr/TrendDown";

import { createAppIcon } from "@/components/createAppIcon";

export const TrendingDownIcon = /* @__PURE__ */ createAppIcon(PhosphorTrendDownIcon);
